import { LookupType } from './Enums/LookupType.enum';
import { ITableColumnConfig } from './table-schema/table-schema';

export const COLUMNS_BY_LOOKUP_TYPE: Partial<Record<LookupType, string[]>> = {
  [LookupType.PROJEKT_TYPE]: ['groupView'],
  [LookupType.PROJEKT_STATI]: ['standard', 'closedStatus'],
  [LookupType.RESSOURCENKLASSEN]: ['textValue', 'hexColorPair'],
};

export const COLUMNS_BY_LOOKUP_TYPE_DEFINITIONS: Record<
  string,
  Partial<ITableColumnConfig>
> = {
  groupView: {
    id: 'groupView',
    title: ['COMMON.PROJECTKIND.GROUPVIEW'],
    accessor: 'groupView',
    width: 100,
    cell: {
      type: 'Checkbox',
    },
  },
  standard: {
    id: 'standard',
    title: ['COMMON.DEFAULT'],
    accessor: 'standard',
    width: 100,
    cell: {
      type: 'Checkbox',
    },
  },
  closedStatus: {
    id: 'closedStatus',
    title: ['COMMON.CLOSED'],
    accessor: 'closedStatus',
    width: 100,
    cell: {
      type: 'Checkbox',
    },
  },
  textValue: {
    id: 'textValue',
    title: ['COMMON.GROUPING'],
    accessor: 'textValue',
    width: 150,
    cell: {
      type: 'Text',
    },
  },
  hexColorPair: {
    id: 'hexColorPair',
    title: ['COMMON.COLOR'],
    accessor: 'hexColorPair',
    width: 100,
    cell: {
      type: 'Color',
    },
  },
};

export function shouldShowLookupField(
  lookupType?: LookupType | null,
  fieldName?: string
): boolean {
  if (!lookupType || !fieldName) {
    return false;
  }

  const visibleFields = COLUMNS_BY_LOOKUP_TYPE[lookupType];
  return visibleFields?.includes(fieldName) ?? false;
}
